import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Router } from "@angular/router";

// Components
import { FormValidationComponent } from "src/app/modules/shared/components/form-validation/form-validation.component";

// Configurations
import { languageToPnpConfigurations, zimplerLanguageToCountryConfigurations } from "src/app/configurations/main.configurations";

// Environments
import { environment } from "src/environments/environment";

// Libraries
import * as _ from "underscore";
import * as $ from "jquery";

// Services
import { PayNPlayCashierService } from "src/app/modules/account/services/pay-n-play-cashier.service";
import { TranslationService } from "src/app/modules/shared/services/translation.service";
import { UserDetailsService } from "src/app/modules/user/services/user-details.service";
import { DeepLinksService } from "src/app/modules/shared/services/deep-links.service";
import { EmitterService } from "src/app/modules/shared/services/emitter.service";
import { CommonService } from "src/app/modules/shared/services/common.service";
import { GtmService } from "src/app/modules/shared/services/gtm.service";
import { UtilityService } from "src/app/utility/utility.service";

// Utilities
import { CustomValidators } from "src/app/utility/custom-validator";

@Component({
  selector: "app-paynplay-cashier",
  templateUrl: "./pay-n-play-cashier.component.html",
  styleUrls: ["./pay-n-play-cashier.component.scss"],
})
export class PayNPlayCashierComponent extends FormValidationComponent
  implements OnInit, OnDestroy {
  minDWLimitValue;
  maxDWLimitValue;
  depositAmount: number = 0;
  windowType: string;
  paymentProcessStep: string = "step1";
  transactionType;
  isInitiateDepositTriggred: boolean = false;
  timerInstance: NodeJS.Timer;
  callingFrom: string;
  calledFromComponent: string;
  isButtonLoader: boolean = false;
  langCode: string;
  currencySymbol: string;
  destroy$: Subject<boolean> = new Subject<boolean>();
  isFocus: boolean = false;
  isVisible: boolean = false;
  isLoggedIn: any;
  errorMessage;
  avialableDepositBonusDetails: any;
  clearSelectedBonus: boolean = false;
  selectedBonus: any;
  gameGroupGameSub: Subscription;
  games: any;
  isBonusData: boolean = true;

  @HostListener("window:resize") onResize() {
    this.getWindowType();
  }

  @HostListener("window:orientationchange") onRotate() {
    this.getWindowType();
  }

  @HostListener("window:message", ["$event"]) onMessage(e) {
    if (e && e.data && e.data.message === "deposit-transactionStatus") {
      this.paymentProcessStep = "step4";
      if (!this.isInitiateDepositTriggred) {
        this.isInitiateDepositTriggred = true;
      }
      this.getPNPUserFromTransaction();
    }

    if (e && e.data && e.data.message === "withdraw-transactionStatus") {
      this.paymentProcessStep = "step4";
      if (!this.isInitiateDepositTriggred) {
        this.isInitiateDepositTriggred = true;
      }
      this.getWithdrawTransactionStatus();
    }
  }

  @HostListener("keydown", ["$event"]) onKeydown(e) {
    if (document.getElementById("formInputValue")) {
      var inputValue =
        (document.getElementById("formInputValue") as HTMLInputElement).value
          .length - 1;
      if (e.which === 8 && inputValue <= 0) {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private customValidators: CustomValidators,
    private userDetailsService: UserDetailsService,
    private paynplayCashierService: PayNPlayCashierService,
    private emitterService: EmitterService,
    public utils: UtilityService,
    private translationService: TranslationService,
    private gtmService: GtmService,
    private deepLinkService: DeepLinksService
  ) {
    super(utils);
    this.userDetailsService.currencySymbolSb$
      .pipe(takeUntil(this.destroy$))
      .subscribe((currencySymbol) => {
        this.currencySymbol = currencySymbol;
      });
    this.isLoggedIn = this.utils.isUserLoggedIn();
    this.commonService.loginComplete$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
        if (this.isLoggedIn) {
          this.getCashoutTxnLimits();
        }
      });
    this.commonService.logOutComplete$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.isLoggedIn = false;
      });
    /**This call is need on refresh to check emial Id updated by user or not
     * If not we open a popup & ask user to update it..
     */
    this.checkLoginStatus();
    this.paynplayCashierService.initiateLogin$
      .pipe(takeUntil(this.destroy$))
      .subscribe((txnType) => {
        this.zimplerPayAndPlayInit(txnType);
      });

    this.paynplayCashierService.initiateDespoit$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.callingFrom = "deposit";
        this.isInitiateDepositTriggred = true;
        this.initiateDespoitHandler(data);
      });

    this.paynplayCashierService.initiateWithdraw$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.callingFrom = "withdraw";
        this.paymentProcessStep = "step1";
        this.updateLimits();
        this.addOverFlowHideen();
        this.isInitiateDepositTriggred = true;
      });
    /**@@
     * This condition/blocked code is for only mobile device
     * as zimpler thrid party url we open in new window instead of iframe
     */
    this.paynplayCashierService.processUserTransaction$
      .pipe(takeUntil(this.destroy$))
      .subscribe((message) => {
        if (message && message === "deposit-transactionStatus") {
          this.paymentProcessStep = "step4";
          this.isInitiateDepositTriggred = true;
          this.getPNPUserFromTransaction();
        }

        if (message && message === "withdraw-transactionStatus") {
          this.paymentProcessStep = "step4";
          this.isInitiateDepositTriggred = true;
          this.getWithdrawTransactionStatus();
        }
      });
    this.langCode = this.utils.getLangCode();
    this.translationService.langCodeSb$
      .pipe(takeUntil(this.destroy$))
      .subscribe((langCode) => {
        this.langCode = langCode;
      });
  }
  zimplerForm = this.formBuilder.group({
    amount: ["", [this.customValidators.required]],
  });

  decideDepositFlow() {
    if (this.callingFrom === "deposit") {
      this.zimplerPayAndPlayInit();
    } else if (this.callingFrom === "withdraw") {
      this.zimplerWithdrawInit();
    }
  }

  initiateDespoitHandler(data) {
    if (
      data &&
      [
        "accountMenu",
        "bottomNavigation",
        "leftMenu",
        "deepLink",
        "payment-rewards",
        "all-rewards",
        "pnp-cashier",
      ].indexOf(data["callingFrom"]) > -1
    ) {
      this.clearIframeData();
      this.paymentProcessStep = "step1";
      this.updateLimits();
      this.isInitiateDepositTriggred = true;
      this.addOverFlowHideen();
      if (this.isLoggedIn) {
        this.checkForActiveBonus(true);
      }
    } else if (data["callingFrom"] === "customBanner") {
      this.paymentProcessStep = "step4";
      this.updateLimits();
      this.zimplerForm.controls["amount"].setValue(data["amount"]);
      this.isInitiateDepositTriggred = true;
      if (this.isLoggedIn) {
        this.showBonusCards();
      } else {
        this.zimplerPayAndPlayInit();
      }
    }
  }

  updateLimits() {
    if (this.callingFrom === "deposit") {
      this.updateDepositLimits();
    }
    if (this.callingFrom === "withdraw") {
      this.updateWithdrawLimits();
    }
  }

  updateDepositLimits() {
    let depositLimits = this.paynplayCashierService.depositLimits;
    if (depositLimits["minLimit"] && depositLimits["maxLimit"]) {
      this.applyMinMaxFromValidation(
        depositLimits["minLimit"],
        depositLimits["maxLimit"],
        "deposit"
      );
    } else {
      this.getPNPMinMaxTxnLimits();
    }
  }

  updateWithdrawLimits() {
    let withdrawLimits = this.paynplayCashierService.cashOutLimits;
    if (withdrawLimits["minLimit"] && withdrawLimits["maxLimit"]) {
      this.applyMinMaxFromValidation(
        withdrawLimits["minLimit"],
        withdrawLimits["maxLimit"],
        "withdraw"
      );
    } else {
      this.getCashoutTxnLimits(true);
    }
  }

  applyMinMaxFromValidation(minLimit, maxLimit, callingFrom) {
    if (callingFrom === "withdraw") {
      let withdrawableBalance: number = this.userDetailsService.getWithdrawableBalance();
      this.zimplerForm.controls["amount"].setValidators(
        this.customValidators.minValueNumber(
          minLimit,
          maxLimit,
          callingFrom,
          withdrawableBalance
        )
      );
    } else {
      this.zimplerForm.controls["amount"].setValidators(
        this.customValidators.minValueNumber(minLimit, maxLimit, callingFrom)
      );
    }
  }

  checkLoginStatus() {
    Promise.resolve(this.commonService.getLoginStatus()).then((data) => {
      if (data && data["status"]) {
        this.checkIsEmailUpdated();
      }
    });
  }

  ngOnInit() {
    this.getPNPMinMaxTxnLimits();
    if (this.isLoggedIn) {
      this.getCashoutTxnLimits();
    }
    this.getWindowType();
  }
  getWindowType() {
    var ww = document.body.clientWidth;
    if (ww >= 1024) {
      this.windowType = "device";
    } else {
      this.windowType = "mobile";
    }
  }

  getPNPMinMaxTxnLimits() {
    let minMaxRequestData = {
      option: "ZIMPLER_DIRECT",
      currency: this.userDetailsService.getCurrencyCode(),
    };
    this.paynplayCashierService
      .getPNPMinMaxTxnLimits(minMaxRequestData)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data && data["minLimit"] && data["maxLimit"]) {
          this.applyMinMaxFromValidation(
            data["minLimit"],
            data["maxLimit"],
            "deposit"
          );
        }
      });
  }

  getCashoutTxnLimits(isapplyValidation = false) {
    let cashoutTxnLimitsReq = {
      txnType: "cashout",
    };
    this.paynplayCashierService
      .getCashoutTxnLimits(cashoutTxnLimitsReq)
      .pipe(takeUntil(this.destroy$))
      .subscribe((cashOutData) => {
        if (cashOutData && cashOutData["minLimit"] && cashOutData["maxLimit"]) {
          this.minDWLimitValue = cashOutData["minLimit"];
          this.maxDWLimitValue = cashOutData["maxLimit"];
          if (isapplyValidation) {
            this.applyMinMaxFromValidation(
              cashOutData["minLimit"],
              cashOutData["maxLimit"],
              "withdraw"
            );
          }
        }
      });
  }

  showBonusCards() {
    this.paymentProcessStep = "step2";
    this.addOverFlowHideen();
  }

  zimplerPayAndPlayInit(txnType = "DEPOSIT") {
    this.isButtonLoader = true;
    this.clearIframeData();
    if (
      (this.zimplerForm.valid && txnType === "DEPOSIT") ||
      txnType === "LOGIN"
    ) {
      let initRequestData = this.getPayNplayInitRequestData(txnType);
      this.paynplayCashierService
        .zimplerPayAndPlayInit(initRequestData)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          this.isButtonLoader = false;
          if (data["status"] === "SUCCESS" && data["redirectURL"]) {
            sessionStorage.setItem("txnId", data["txnId"]);
            if (this.windowType === "mobile") {
              window.open(data["redirectURL"], "_self");
            } else {
              this.paymentProcessStep = "step3";
              this.isInitiateDepositTriggred = true;
              setTimeout(() => {
                let $iframe = $(
                  '<iframe src="' + data["redirectURL"] + '" ></iframe>'
                );
                $(".zimplerIframeContainer").append($iframe);
              });
              this.addOverFlowHideen();
            }
            if (txnType === "LOGIN") {
              this.gtmService.trackLoginGTMEvent("open");
            } else if (txnType === "DEPOSIT") {
              this.gtmService.trackDepositGTMEvent("open");
            }
          } else {
            this.isInitiateDepositTriggred = true;
            this.switchToNextStep(
              "failure",
              "step5",
              "zimpler.something_went_wrong_redirection"
            );
          }
        });
    }
  }

  getPayNplayInitRequestData(txnType) {
    /**If we have bonuscode we can pass below in the request object 
     * & property name is bonusCode
     * please add below line for redirection url before you deploy
     *   successURL:environment.siteUrl+'/redirection.html',
         failureURL:environment.siteUrl+'/redirection.html',
         redirectURL:environment.siteUrl+'/redirection.html'
     * */
    let initRequestData = {
      amount:
        txnType === "DEPOSIT" ? this.zimplerForm.controls["amount"].value : 0,
      countryCode: zimplerLanguageToCountryConfigurations[this.langCode],
      language: languageToPnpConfigurations[this.langCode],
      currencyCode: this.userDetailsService.getCurrencyCode(),
      site: environment.websiteName,
      siteDisplayName: environment.website,
      txnType: txnType,
      successURL:
        window.location.origin + "/redirection.html?transactionType=deposit",
      failureURL:
        window.location.origin + "/redirection.html?transactionType=deposit",
      redirectURL:
        window.location.origin + "/redirection.html?transactionType=deposit",
    };
    if (this.getActiveBonus()) {
      initRequestData["bonusCode"] = this.getActiveBonus();
    }
    return initRequestData;
  }

  getActiveBonus() {
    const bonusDetails = this.commonService.getActiveDepositBonus();
    if (bonusDetails && Object.keys(bonusDetails).length > 0) {
      return bonusDetails["bonusCode"];
    }
    return "";
  }

  clearIframeData() {
    if ($(".zimplerIframeContainer")) {
      $(".zimplerIframeContainer").empty();
    }
    if (this.transactionErrorMessage) {
      this.transactionErrorMessage = "";
    }
    if (this.transactionSuccessMessage) {
      this.transactionSuccessMessage = "";
    }
    if (this.timerInstance) {
      clearInterval(this.timerInstance);
    }
  }

  requestLoopCount = 0;
  getPNPUserFromTransaction() {
    this.addOverFlowHideen();
    let transactionData = {
      txnId: sessionStorage.getItem("txnId"),
    };
    this.paynplayCashierService
      .getPNPUserFromTransaction(transactionData)
      .pipe(takeUntil(this.destroy$))
      .subscribe((transactionStatuData) => {
        this.handleRequestLooping(transactionStatuData);
      });
  }

  handleRequestLooping(transactionStatuData) {
    if (
      this.requestLoopCount < 5 &&
      transactionStatuData &&
      transactionStatuData["txnStatus"] === "KYC_VERIFIED"
    ) {
      // (transactionStatuData['txnStatus'] === 'KYC_VERIFIED' || transactionStatuData['txnStatus'] === 'INIT')){
      setTimeout(() => {
        this.requestLoopCount++;
        this.getPNPUserFromTransaction();
      }, 3000);
    } else {
      this.requestLoopCount = 0;
      if (transactionStatuData) {
        this.navigateBasedOnTxStatus(transactionStatuData);
      }
    }
  }

  transactionErrorMessage: string;
  transactionSuccessMessage: string;
  navigateBasedOnTxStatus(transactionStatuData) {
    const {
      status,
      txnStatus,
      externalEcrId,
      errorCode,
    } = transactionStatuData;
    this.verifyAndPushGTMEvent(status, txnStatus, transactionStatuData);
    if (status === "SUCCESS" && externalEcrId) {
      this.successTranctionHanlder(txnStatus, transactionStatuData);
    }
    if (status === "FAILURE" && errorCode === 100159) {
      this.failureTransactionHanlder(txnStatus, transactionStatuData);
    }
  }
  tnxDataBeforeQuickRegister;
  verifyAndPushGTMEvent(status, txnStatus, transactionData) {
    /**
     * This IF case occur only for user deposit for first on our production
     * At this time user is not yet registered
     * so in this case we have persist data & push end of 3rd step
     * step1:successful quick registration,
     * step 2:successful login then after we can have to push data..
     */
    if (
      status === "FAILURE" &&
      txnStatus === "DEPOSIT_SUCCESS" &&
      !localStorage.getItem("hir_user")
    ) {
      this.tnxDataBeforeQuickRegister = {
        txnStatus: txnStatus,
        txnId: transactionData["txnId"],
        amount: transactionData["amount"],
      };
    } else if (txnStatus !== "LOGIN_WITHOUT_DEPOSIT" && txnStatus !== "INIT") {
      const userProfileData = this.userDetailsService.getUserProfileDetails();
      if (userProfileData) {
        transactionData = {
          ...transactionData,
          ...{
            externalEcrId: userProfileData["playerID"],
          },
        };
      }
      this.gtmService.trackDepositGTMEvent(status, transactionData);
    }
  }
  successTranctionHanlder(txnStatus, transactionStatuData) {
    switch (txnStatus) {
      case "DEPOSIT_SUCCESS":
      case "CASHIER_TRANSFER_SUCCESS":
      case "CASHIER_INIT_DEPOSIT_SUCCESS":
        if (!localStorage.getItem("hir_user")) {
          this.getPNPThirdPartyLogin(transactionStatuData["txnId"], "deposit");
        } else {
          this.switchToNextStep(
            "successful",
            "step5",
            "zimpler.deposit_success_msg"
          );
        }
        break;
      case "KYC_VERIFIED":
        this.backToCashier();
        break;
      case "CASHIER_INIT_DEPOSIT_FAILED":
        this.switchToNextStep(
          "failure",
          "step5",
          "zimpler.cashier_init_deposit_failed"
        );
        break;
      case "LOGIN_WITHOUT_DEPOSIT":
        /**
         * Else condition encounter when user is already logged in with
         * DEMOUSER2 & try to deposit with DEMOUSER4 user
         * In general world on Production we don't encounter this case.
         */
        if (!localStorage.getItem("hir_user")) {
          this.getPNPThirdPartyLogin(transactionStatuData["txnId"], "login");
        } else {
          this.switchToNextStep(
            "failure",
            "step5",
            "zimpler.something_went_wrong"
          );
        }
        break;
      case "CATEGORY_LIMITS_EXCEEDED":
        {
          this.switchToNextStep(
            "failure",
            "step5",
            "zimpler.category_limits_excceed"
          );
        }
        break;
      case "DEPOSIT_NOT_ALLOWED":
        {
          this.switchToNextStep(
            "failure",
            "step5",
            "zimpler.deposit_not_allowed"
          );
        }
        break;
      case "RG_COOL_OFF":
        {
          this.switchToNextStep("failure", "step5", "zimpler.rg_cool_off");
        }
        break;
    }
  }

  failureTransactionHanlder(txnStatus, transactionStatuData) {
    let message = "";
    switch (txnStatus) {
      case "LOGIN_WITHOUT_DEPOSIT":
        {
          this.switchToNextStep(
            "failure",
            "step5",
            "zimpler.login_without_depositFailureMsg"
          );
        }
        break;
      case "DEPOSIT_SUCCESS":
        if (!localStorage.getItem("hir_user")) {
          this.quickRegisterZimpler();
        } else {
          this.switchToNextStep(
            "failure",
            "step5",
            "zimpler.something_went_wrong"
          );
        }
        break;
      case "INIT":
      case "KYC_VERIFIED":
        this.backToCashier();
        break;
    }
  }

  quickRegisterZimpler() {
    let reqRequestData = {
      txnId: sessionStorage.getItem("txnId"),
      emailId: sessionStorage.getItem("txnId") + "@" + environment.website,
      password: Math.random().toString(36).slice(-8),
    };
    if (this.utils.getAffiliateData()) {
      reqRequestData = { ...reqRequestData, ...this.utils.getAffiliateData() };
    }
    this.paynplayCashierService
      .quickRegisterZimpler(reqRequestData)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        let message;
        if (data["status"] === "SUCCESS") {
          this.utils.deleteAffCookies();
          this.getPNPThirdPartyLogin(
            sessionStorage.getItem("txnId"),
            "quick-registration"
          );
        } else {
          this.switchToNextStep(
            "failure",
            "step5",
            "zimpler.quickRegisterFailureMsg"
          );
        }
      });
  }

  getPNPThirdPartyLogin(userTxnId, callingFrom) {
    if (userTxnId) {
      let loginData = {
        txnId: userTxnId,
      };
      this.paynplayCashierService
        .getPNPThirdPartyLogin(loginData)
        .pipe(takeUntil(this.destroy$))
        .subscribe((loginResponse) => {
          if (loginResponse && loginResponse["status"] === "SUCCESS") {
            this.pnpThirdPartyLoginSuccesHanlder(loginResponse, callingFrom);
            this.utils.deleteAffCookies();
            /*Below error code is used for RgCoolOffuser */
          } else if (
            loginResponse["errorCode"] === 100173 &&
            loginResponse["errorDescription"]
          ) {
            let msg = loginResponse["errorDescription"];
            /**Below logic/work around is required to remove crossbrowser issue in safari, firefox & windows */
            let accountLockedDate = new Date(
              Date.parse(
                msg
                  .substr(msg.indexOf(":") + 1)
                  .trim()
                  .replace(" ", "T") + "+02:00"
              )
            );
            const errorDescMsg = this.translationService.instant(
              "zimpler.error_100173_rg_cool_off"
            );
            this.errorMessage = errorDescMsg + accountLockedDate;
            this.switchToNextStep("failure", "step5", this.errorMessage);
          } else {
            this.tnxDataBeforeQuickRegister = undefined;
            this.pnpThirdPartyLoginFailHanlder(loginResponse, callingFrom);
          }
        });
    }
  }

  pnpThirdPartyLoginSuccesHanlder(response, callingFrom) {
    if (callingFrom === "quick-registration") {
      this.switchToNextStep("", "step6", "", "quick-registration");
      this.getProfileBalanceCurrency();
    } else {
      let messageKey = "";
      switch (callingFrom) {
        case "login":
          messageKey = "zimpler.loginSuccessMsg";
          break;
        case "deposit":
          messageKey = "zimpler.depositSuccessMsg";
          break;
        default:
          messageKey = "zimpler.loginSuccessDefaultMsg";
      }
      this.switchToNextStep("successful", "step5", messageKey, callingFrom);
      this.deepLinkService.navigateAfterLogin();
    }
  }

  onEmailSubscriptionUpdate() {
    /**This will triggered only when user doing is first deposit */
    if (this.tnxDataBeforeQuickRegister) {
      const userProfileData = this.userDetailsService.getUserProfileDetails();
      if (userProfileData) {
        this.tnxDataBeforeQuickRegister["externalEcrId"] =
          userProfileData["playerID"];
      }
      this.gtmService.trackDepositGTMEvent(
        "SUCCESS",
        this.tnxDataBeforeQuickRegister,
        true
      );
      this.tnxDataBeforeQuickRegister = undefined;
    }
    this.backToCashier();
  }

  pnpThirdPartyLoginFailHanlder(response, callingFrom) {
    let messageKey = "";
    switch (callingFrom) {
      case "login":
        messageKey = "zimpler.loginFailureMsg";
        break;
      case "deposit":
        messageKey = "zimpler.deposit_LoginFailureMsg";
        break;
      case "quick-registration":
        messageKey = "zimpler.quick_registration_LoginFailureMsg";
        break;
      default:
        messageKey = "zimpler.something_went_wrong";
    }
    this.switchToNextStep("failure", "step5", messageKey);
  }

  switchToNextStep(status, stepNumber, messageKey, callingFrom?) {
    this.paymentProcessStep = stepNumber;
    if (status === "failure" && messageKey) {
      this.transactionErrorMessage = this.translationService.instant(
        messageKey
      );
    }
    if (status === "successful" && messageKey) {
      this.transactionSuccessMessage = this.translationService.instant(
        messageKey
      );
    }
    if (callingFrom !== "quick-registration") {
      this.timerInstance = setTimeout(() => {
        this.backToCashier();
      }, 3000);
    }
  }

  setTransactionAmount(event) {
    if (event) {
      this.zimplerForm.controls["amount"].setValue(event.target.value);
      this.isVisible = true;
    }
  }

  uncheckQuickPicks() {
    const inputRadioElement = document.querySelectorAll(
      '.quickPick__wrap input[type="radio"]:checked'
    ) as NodeListOf<Element>;
    if (inputRadioElement && inputRadioElement.length > 0) {
      (inputRadioElement[0] as HTMLInputElement).checked = false;
    }
  }

  isButtonDisabled(formName) {
    return this.utils.isButtonDisabled(formName);
  }

  backToCashier() {
    this.isButtonLoader = false;
    this.isVisible = false;
    this.paymentProcessStep = "step1";
    localStorage.removeItem("txnId");
    this.removeOverFlowHidden();
    this.isInitiateDepositTriggred = false;
    this.paymentProcessStep = "step1";
    this.zimplerForm.controls["amount"].setValue("");
    this.zimplerForm.reset();
    this.paynplayCashierService.broadCastZimplerProcessCompleted();
    this.selectedBonus = undefined;
    if (localStorage.getItem("hir_user")) {
      this.checkIsEmailUpdated("loginSucces");
    }
    if (this.commonService.getActiveDepositBonus()) {
      this.commonService.setActiveDepositBonus({});
    }
  }

  addOverFlowHideen() {
    this.utils.addClassToAppBody("overflow-hidden");
    this.utils.addClassToAppBody("zimplerModalOpen");
  }

  removeOverFlowHidden() {
    this.utils.removeClassFromAppBody("overflow-hidden");
    this.utils.removeClassFromAppBody("zimplerModalOpen");
  }

  checkIsEmailUpdated(callingFrom?: string) {
    const userProfileDetails = this.userDetailsService.userBalanceDetails;
    if (userProfileDetails && userProfileDetails["email"]) {
      this.doEmailMatch(userProfileDetails["email"], callingFrom);
    } else {
      Promise.resolve(this.commonService.getProfileBalanceCurrency()).then(
        (data) => {
          if (data && data["profile"] && data["profile"]["email"]) {
            this.doEmailMatch(data["profile"]["email"], callingFrom);
          }
        }
      );
    }
  }

  doEmailMatch(emailId, callingFrom) {
    let numberRegex = new RegExp("^[0-9]+$");
    if (emailId) {
      let emailSegments = emailId.split("@");
      if (
        numberRegex.test(emailSegments[0]) &&
        emailSegments[1].startsWith(environment.website.toLowerCase())
      ) {
        this.paymentProcessStep = "step6";
        this.isInitiateDepositTriggred = true;
        this.addOverFlowHideen();
      }
    }
  }

  /**This functional will be called from payment rewards component
   * after user clicks add bonus or No thanks button then we proccess
   * zimpler payment init flow to complete deposit
   */
  navigateToDeposit() {
    this.zimplerPayAndPlayInit();
  }

  /**********************withdraw flow start from here**************************/

  zimplerWithdrawInit(txnType = "WITHDRAW") {
    this.isButtonLoader = true;
    this.clearIframeData();
    if (this.zimplerForm.valid && txnType === "WITHDRAW") {
      let withdrawRequestData = {
        depositAmount: this.zimplerForm.controls["amount"].value,
        paymentMethod: "ZIMPLER_DIRECT",
        comments: "system",
        /**for deposit redirection urls are coming from CMS,
         * where as for withdraw redirection url is from php code level which
         * is hard coded on php side
         * just adding here for reference
         * whether success or failure use will be naviagted to below url
         * which we are handing from app router only widthdraw due some
         * dependance from php side
         *cashier/callback/ZIMPLER_DIRECT/ctctrvctrctrtvctrctrctctctc?paymentType=cashout
         */
      };
      this.paynplayCashierService
        .zimplerWithdrawInit(withdrawRequestData)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          if (data["status"] === "SUCCESS" && data["redirectURL"]) {
            sessionStorage.setItem("txnId", data["txnId"]);
            if (this.windowType === "mobile") {
              window.open(data["redirectURL"], "_self");
            } else {
              this.paymentProcessStep = "step3";
              this.isInitiateDepositTriggred = true;
              setTimeout(() => {
                let $iframe = $(
                  '<iframe src="' + data["redirectURL"] + '" ></iframe>'
                );
                $(".zimplerIframeContainer").append($iframe);
              });
              this.addOverFlowHideen();
            }
          } else if (data["status"] === "SUCCESS") {
            this.switchToNextStep(
              "successful",
              "step5",
              "zimpler.withdrawSuccessWaitingApproval"
            );
          } else {
            this.switchToNextStep(
              "failure",
              "step5",
              "zimpler.something_went_wrong_redirection"
            );
          }
          this.isButtonLoader = false;
        });
    }
  }

  getWithdrawTransactionStatus() {
    if (sessionStorage.getItem("txnId")) {
      const data = {
        txnId: sessionStorage.getItem("txnId"),
        type: "CASHOUT",
      };
      this.paynplayCashierService
        .getUserPSPTranstionStatus(data)
        .pipe(takeUntil(this.destroy$))
        .subscribe((response) => {
          if (response && response["status"] === "SUCCESS") {
            this.withdrawTnxSuccessHandler(response);
          } else {
            this.withdrawTnxFailureHandler(response);
          }
        });
    }
  }

  withdrawTnxSuccessHandler(data) {
    let messageKey = "";
    if (data["actualStatusInDB"] === "co_initiated") {
      messageKey = "zimpler.withdrawSuccessWaitingApproval";
    } else {
      messageKey = "zimpler.withdrawSuccess";
    }
    this.switchToNextStep("successful", "step5", messageKey);
  }

  withdrawTnxFailureHandler(data) {
    this.switchToNextStep("failure", "step5", "zimpler.withdrawRequestfailed");
  }

  /**
   * Below code complete deal with passing of bonus code
   * in make transaction
   * Below we check is there any active bonus already been selected &
   * user navigated to cashier like we have reward area where user can click on
   * reward card & land on cashier page
   * so we store bonus selected in rewards component into service
   * & fetch back here to apply & passed it on pass in payment flow
   */

  checkForActiveBonus(eligibleBonusdata?) {
    let activeDepositBonus = this.commonService.getActiveDepositBonus();
    if (activeDepositBonus && activeDepositBonus["bonusCode"]) {
      this.selectedBonus = activeDepositBonus;
    }
    if (!eligibleBonusdata) {
      this.isBonusData = false;
    } else {
      this.isBonusData = true;
    }
  }

  selectedBonusHandler(data) {
    this.selectedBonus = data;
    if (data && data.bonusCode) {
      this.clearSelectedBonus = false;
    } else {
      this.clearSelectedBonus = true;
    }
  }

  getProfileBalanceCurrency() {
    this.commonService.getProfileBalanceCurrency().then((data) => {
      if (data && data["profile"]["jurisdiction"]) {
        this.commonService.setUserJurisdiction(data["profile"]["jurisdiction"]);
        if (this.commonService.getUserJurisdiction() === "estonia") {
          this.emitterService.broadCastLimitsRegulatoryPopup(true);
        }
      }
    });
  }

  ngOnDestroy() {
    /**
     * We have to clear saved active bonus if their is any active bonus saved in our local,
     * basically when user navigaye from all -rewards deposit card we store it their
     * & activate that bonus by default once he lands on cashier page
     */
    if (this.commonService.getActiveDepositBonus()) {
      this.commonService.setActiveDepositBonus(undefined);
    }
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
